// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ViewMap - Full Screen Map Experience (Like WatchLive) */
.view-map-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  display: block;
}

/* Selected Mark Information Display - in the white row under buttons */
.view-map-container .selected-mark-info {
  position: absolute;
  top: 60px; /* Right below the MapHeader */
  left: 0;
  right: 0;
  background: white;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 16px;
  z-index: 1000;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.view-map-container .selected-mark-info .mark-details {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  flex-wrap: wrap;
}

.view-map-container .selected-mark-info .mark-label {
  font-weight: 600;
  color: #2c3e50;
  font-size: 16px;
}

.view-map-container .selected-mark-info .mark-type,
.view-map-container .selected-mark-info .mark-position {
  color: #555;
}

.view-map-container .selected-mark-info .mark-status {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: #e8f5e8;
  color: #4caf50;
}

/* Map container positioning - Full screen starting from top */
.view-map-container .course-map-view {
  position: absolute !important;
  top: 0 !important; /* Start from very top */
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  min-width: 320px !important;
  min-height: 500px !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  z-index: 1 !important; /* Low z-index so header stays on top */
  overflow: hidden !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Loading and error states */
.view-map-container .loading-message,
.view-map-container .error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
}

.view-map-container .loading-message h3,
.view-map-container .error-message h3 {
  margin: 20px 0 10px 0;
  color: #2c3e50;
  font-size: 18px;
}

.view-map-container .error-message p {
  margin: 10px 0 20px 0;
  color: #7f8c8d;
  line-height: 1.5;
}

.view-map-container .spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Message containers in map view */
.view-map-container .no-course-message,
.view-map-container .map-error-recovery {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
}

.view-map-container .no-course-message h3,
.view-map-container .map-error-recovery h3 {
  margin: 20px 0 10px 0;
  color: #2c3e50;
  font-size: 18px;
}

.view-map-container .no-course-message p,
.view-map-container .map-error-recovery p {
  margin: 10px 0 20px 0;
  color: #7f8c8d;
  line-height: 1.5;
}

.view-map-container .back-button,
.view-map-container .back-to-config-button {
  padding: 12px 20px;
  background: #4A90E2;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.view-map-container .back-button:hover,
.view-map-container .back-to-config-button:hover {
  background: #357ABD;
}

/* Ensure map takes full space */
.view-map-container .unified-course-map,
.view-map-container .unified-course-map > div {
  width: 100% !important;
  height: 100% !important;
  position: relative !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ViewMap.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,SAAS,EAAE,8BAA8B;EACzC,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;EAC7B,iBAAiB,EAAE,wBAAwB;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB,EAAE,uCAAuC;EAC9D,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B","sourcesContent":["/* ViewMap - Full Screen Map Experience (Like WatchLive) */\n.view-map-container {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  min-height: 100vh;\n  overflow: hidden;\n  background: #f5f5f5;\n  display: block;\n}\n\n/* Selected Mark Information Display - in the white row under buttons */\n.view-map-container .selected-mark-info {\n  position: absolute;\n  top: 60px; /* Right below the MapHeader */\n  left: 0;\n  right: 0;\n  background: white;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 12px 16px;\n  z-index: 1000;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.view-map-container .selected-mark-info .mark-details {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 14px;\n  flex-wrap: wrap;\n}\n\n.view-map-container .selected-mark-info .mark-label {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 16px;\n}\n\n.view-map-container .selected-mark-info .mark-type,\n.view-map-container .selected-mark-info .mark-position {\n  color: #555;\n}\n\n.view-map-container .selected-mark-info .mark-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  background: #e8f5e8;\n  color: #4caf50;\n}\n\n/* Map container positioning - Full screen starting from top */\n.view-map-container .course-map-view {\n  position: absolute !important;\n  top: 0 !important; /* Start from very top */\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  min-width: 320px !important;\n  min-height: 500px !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  z-index: 1 !important; /* Low z-index so header stays on top */\n  overflow: hidden !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Loading and error states */\n.view-map-container .loading-message,\n.view-map-container .error-message {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  padding: 40px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-width: 400px;\n  width: 90%;\n}\n\n.view-map-container .loading-message h3,\n.view-map-container .error-message h3 {\n  margin: 20px 0 10px 0;\n  color: #2c3e50;\n  font-size: 18px;\n}\n\n.view-map-container .error-message p {\n  margin: 10px 0 20px 0;\n  color: #7f8c8d;\n  line-height: 1.5;\n}\n\n.view-map-container .spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Message containers in map view */\n.view-map-container .no-course-message,\n.view-map-container .map-error-recovery {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  padding: 40px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-width: 400px;\n  width: 90%;\n}\n\n.view-map-container .no-course-message h3,\n.view-map-container .map-error-recovery h3 {\n  margin: 20px 0 10px 0;\n  color: #2c3e50;\n  font-size: 18px;\n}\n\n.view-map-container .no-course-message p,\n.view-map-container .map-error-recovery p {\n  margin: 10px 0 20px 0;\n  color: #7f8c8d;\n  line-height: 1.5;\n}\n\n.view-map-container .back-button,\n.view-map-container .back-to-config-button {\n  padding: 12px 20px;\n  background: #4A90E2;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 auto;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.view-map-container .back-button:hover,\n.view-map-container .back-to-config-button:hover {\n  background: #357ABD;\n}\n\n/* Ensure map takes full space */\n.view-map-container .unified-course-map,\n.view-map-container .unified-course-map > div {\n  width: 100% !important;\n  height: 100% !important;\n  position: relative !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
